export interface SelfProfessional {
    agbCode: string;
    initials: string;
    lastName: string;
    gender?: 1 | 2;
}
